import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import GovBar from "./components/GovBar";
import InstitutionalMenu from "./components/InstitutionalMenu";
import Header from "./components/Header";
import AccessibilityBar from "./components/AccessibilityBar";
import NotFound from './components/NotFound';
import Footer from "./components/Footer";
import RouteFocus from "./components/RouteFocus";
import TrailingSlashRedirect from "./components/TrailingSlashRedirect";

const Home              = lazy(() => import('./pages/Home'));
const LoginRegister     = lazy(() => import('./pages/LoginRegister'));
const PasswordReset     = lazy(() => import('./pages/PasswordReset'));
const ResetPassword     = lazy(() => import('./pages/ResetPassword'));
const ChangePassword    = lazy(() => import('./pages/ChangePassword'));
const Plans             = lazy(() => import('./pages/Plans'));
const PitchProfessional = lazy(() => import('./pages/PitchProfessional'));
const PitchResultView   = lazy(() => import('./pages/PitchResultView'));
const PmvValidation     = lazy(() => import('./pages/PmvValidation'));
const PmvResultView     = lazy(() => import('./pages/PmvResultView'));
const OportunidadesMap  = lazy(() => import('./pages/OportunidadesMap'));
const OppResultView     = lazy(() => import('./pages/OppResultView'));
const BmcResultView     = lazy(() => import('./pages/BmcResultView'));
const UnderConstruction = lazy(() => import('./pages/UnderConstruction'));
const Resources         = lazy(() => import('./pages/Resources'));
const SiteMap           = lazy(() => import('./pages/SiteMap'));
const TermsConditions   = lazy(() => import('./pages/TermsConditions'));
const PerfilProfesional = lazy(() => import('./pages/PerfilProfesional'));
const PerfilResultView  = lazy(() => import('./pages/PerfilResultView'));
const MentoriaIA        = lazy(() => import('./pages/MentoriaIA'));

const PageLoader = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="w-10 h-10 border-4 border-[#e2e8f0] border-t-[#003f81] rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <AuthProvider>
      <>
        <RouteFocus />
        <TrailingSlashRedirect />
        <a
          href="#contenido-principal"
          className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[2000] focus:bg-cobalt focus:text-white focus:px-4 focus:py-2 focus:rounded focus:font-semibold focus:shadow-lg"
        >
          Saltar al contenido principal
        </a>
        <GovBar />
        <Header />
        <InstitutionalMenu />
        <AccessibilityBar />
        <main id="contenido-principal" tabIndex={-1} className="focus:outline-none">
          <Suspense fallback={<PageLoader />}>
            <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/login' element={<LoginRegister />} />
            <Route path='/under-construction' element={<UnderConstruction />} />
            <Route path='/plans/bmc' element={<Plans />} />
            <Route path='/plans/bmc/result' element={<BmcResultView />} />
            <Route path='/plans/pitch' element={<PitchProfessional />} />
            <Route path='/plans/pitch/result' element={<PitchResultView />} />
            <Route path='/plans/pmv' element={<PmvValidation />} />
            <Route path='/plans/pmv/result' element={<PmvResultView />} />
            <Route path='/plans/opp' element={<OportunidadesMap />} />
            <Route path='/plans/opp/result' element={<OppResultView />} />
            <Route path='/forgot-password' element={<PasswordReset />} />
            <Route path='/reset-password/:uid/:token' element={<ResetPassword />} />
            <Route path='/change-password' element={<ChangePassword />} />
            <Route path='/recursos' element={<Resources />} />
            <Route path='/mapa-del-sitio' element={<SiteMap />} />
            <Route path='/terminos-y-condiciones' element={<TermsConditions />} />
            <Route path='/mentoria-ia' element={<MentoriaIA />} />
            <Route path='/profile/perfil' element={<PerfilProfesional />} />
            <Route path='/profile/perfil/result' element={<PerfilResultView />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </Suspense>
        </main>
        <Footer />
      </>
    </AuthProvider>
  );
}

export default App;
